import React, { useState, useEffect, useCallback } from "react";
import { useLoading } from "../../../../../context/LoadingContext";
import DataTable from "../../../../Requirement/components/common/ReusableTable";
import {
  fetchData,
  searchfetchQueries,
  postQuery,
} from "../../../../../services/BackendServices";
import dayjs from "dayjs";
import SearchFilter from "../../../../Requirement/components/common/SearchFilter";
import OfferDetails from "../../../requirement/component/OfferDetails";
import AlertModal from "../../../../Requirement/components/common/AlerModel";
import TrustScoreModal from "../../../../../components/common/TrustScoreModal";

const MatchingOffers = ({ requirementDetails, activeUser, onResponse }) => {
  const { setLoading } = useLoading();
  const [offerList, setOfferList] = useState([]);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [productList, setProductList] = useState([]);
  const [allProductMaster, setAllProductMaster] = useState([]);
  const [productGradeList, setProductGradeList] = useState([]);
  const [rowStart, setRowStart] = useState(0);
  const [pageSize] = useState(5);
  const [totalItems, setTotalItems] = useState(0);
  const [productDetails, setProductDetails] = useState({});
  const [INRToUsd] = useState(0.012);
  const [searchValues, setSearchValues] = useState({
    searchOfferProduct: "",
    searchOfferProductGrade: "",
    searchPriceRange: "",
  });

  const priceOptions = [
    { value: "", label: "Select Range" },
    { value: "0-1000", label: "0-1000 USD" },
    { value: "1000-2000", label: "1000-2000 USD" },
    { value: "2000-5000", label: "2000-5000 USD" },
    { value: "Above-5000", label: "Above 5000 USD" },
  ];

  const [modal, setModal] = useState({
    show: false,
    type: "info",
    title: "",
    message: "",
    nextAction: null,
    autoClose: null,
  });

  const [firmOfferModal, setFirmOfferModal] = useState({
    show: false,
    offer: null,
    remarks: "",
    type: "",
  });

  const handleModalClose = () => {
    const action = modal.nextAction;
    setModal((prev) => ({ ...prev, show: false, nextAction: null }));
    if (action) action();
  };

  // State for Verification Status Modal
  const [trustModal, setTrustModal] = useState(false);

  const trustModel = useCallback(() => {
    setTrustModal(true);
  }, []);

  const loadAllProducts = useCallback(async () => {
    setLoading(true);
    try {
      const [allProducts] = await Promise.all([
        searchfetchQueries({
          target: "listAllProducts",
          userOrder: "ProductID",
          rowStart: 0,
          pageSize: 1000,
        }),
      ]);
      setAllProductMaster(allProducts);
      const distinctProducts = Array.from(
        new Map(
          allProducts
            .filter((p) => p.productStatus === "ACTIVE") // ✅ Only include active products
            .map((p) => [p.ProductName, p])
        ).values()
      );
      setProductList(distinctProducts);
    } catch (error) {
      console.error("Error loading products: ", error);
      setAllProductMaster([]);
      setProductList([]);
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  const loadProductGrades = useCallback(
    async (productName) => {
      setLoading(true);
      try {
        const matchingProducts = allProductMaster.filter(
          (p) => p.ProductName === productName
        );
        setProductGradeList(matchingProducts);
      } catch (error) {
        console.error("Error loading product grades: ", error);
      } finally {
        setLoading(false);
      }
    },
    [setLoading, allProductMaster]
  );

  // const getProductDetails = useCallback(async (productId) => {
  //   try {
  //     const response = await fetchData({
  //       target: "listProducts",
  //       userOrder: "ProductID",
  //       rowStart: 0,
  //       pageSize: 1,
  //       filterTerms: { ProductID: productId },
  //     });

  //     if (response.items && response.items.length > 0) {
  //       const product = response.items[0];
  //       setProductDetails({
  //         ProductName: product.ProductName,
  //         Grade: product.Grade,
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error fetching product details:", error);
  //     setProductDetails({});
  //   }
  // }, []);

  const formatPrice = useCallback((price) => {
    if (!price || price === "") return "0.00";
    const numPrice = parseFloat(price);
    return isNaN(numPrice) ? "0.00" : numPrice.toFixed(2);
  }, []);

  const formatDate = useCallback((dateString) => {
    if (!dateString) return "";
    try {
      return dayjs(dateString).format("DD-MM-YYYY");
    } catch (error) {
      console.error("Error formatting date:", error);
      return "";
    }
  }, []);

  const fetchMatchingOffers = useCallback(
    async (searchValues, newRowStart = rowStart) => {
      if (!requirementDetails) return;

      setLoading(true);
      try {
        let priceFilter = {};
        if (searchValues.searchPriceRange) {
          if (searchValues.searchPriceRange === "Above-5000") {
            priceFilter = { CIFSalePriceGTE: 5000 };
          } else {
            const searchPrice = searchValues.searchPriceRange;
            const [min, max] = searchPrice
              .split("-")
              .map((val) => parseFloat(val));
            priceFilter = {
              CIFSalePriceGTE: min,
              CIFSalePriceLTE: max,
            };
          }
        }

        const quantity =
          parseFloat(requirementDetails.Quantity) ||
          parseFloat(requirementDetails.RequestedQuantity) ||
          0;
        const quantityRange = Math.max(50, quantity * 0.05);
        const destinationCountry = requirementDetails.DeliveryLocation
          ? requirementDetails.DeliveryLocation.split("~")[0] || ""
          : "";

        // console.log("productDetails@@", productDetails);
        const matchingProducts = allProductMaster.filter(
          (p) => p.ProductID === requirementDetails.ProductID
        );
        console.log("matchingProducts@@", matchingProducts);
        let rpname = "";
        let rpgrade = "";
        if (matchingProducts.length > 0) {
          rpname = matchingProducts[0].ProductName;
          rpgrade = matchingProducts[0].Grade;
        }

        const body = {
          // target: "listGPOfferDetails",
          target: "listGPOfferRFQDetails",
          userOrder: "CreatedAt DESC",
          rowStart: newRowStart,
          pageSize: pageSize,
          filterTerms: {
            GPOOfferStatusNot: "Firmoffer",
            product: rpname,
            grade: rpgrade,
            DestinationCountry: destinationCountry,
            OriginCountry: requirementDetails.OriginCountry || "",
            QuantityGT: quantity - quantityRange,
            QuantityLT: quantity + quantityRange,
            ...priceFilter,
          },
        };

        const response = await fetchData(body);
        if (Array.isArray(response.items) || Array.isArray(response)) {
          const items = response.items || response || [];
          // Ensure each item has IsShortlist property
          const itemsWithShortlist = items.map((item) => ({
            ...item,
            IsShortlist:
              item.IsShortlist !== undefined ? item.IsShortlist : false,
          }));
          console.log("@@@itemsWithShortlist", itemsWithShortlist);
          const NotFirmOfferlist = itemsWithShortlist
            .filter((item) => item.GPOOfferStatus !== "Firmoffer")
            .map((item) => ({
              ...item,
            }));
          const totalCountNFO = NotFirmOfferlist.length || 0;
          const totalRec = response.total - totalCountNFO;

          setOfferList(NotFirmOfferlist);
          setTotalItems(totalRec || 0);
        } else {
          throw new Error("Unexpected response format");
        }
      } catch (error) {
        console.error("Error loading matching offers:", error);
        setOfferList([]);
        setTotalItems(0);
      } finally {
        setLoading(false);
      }
    },
    [pageSize, rowStart, setLoading, requirementDetails, allProductMaster]
  );

  const handleSearch = (searchValues) => {
    setRowStart(0);
    fetchMatchingOffers(searchValues, 0);
  };

  const handlePageChange = (page) => {
    const newRowStart = (page - 1) * pageSize;
    setRowStart(newRowStart);
    fetchMatchingOffers(searchValues, newRowStart);
  };

  const handleRowClick = (row, event) => {
    console.log("Offer row clicked:", row);
    console.log("Row structure:", Object.keys(row));
    setSelectedOffer(row);
  };

  const handleOfferResponse = () => {
    console.log("Offer response handled");
    setSelectedOffer(null);
    onResponse();
  };

  const Button = ({ label, onClick }) => {
    return (
      <button
        className="submit-btn-more"
        onClick={onClick}
        style={{ width: "140px", padding: "8px 12px" }}
      >
        {label}
      </button>
    );
  };

  const sendTrueToParent = () => {
    console.log("child sendTrueParent");
    onResponse(true); // Sends true to parent via callback
  };

  const handleShortlist = async (offer) => {
    setLoading(true);
    console.log("handleShortlist triggered");
    console.log("shortlistOffer::", offer);
    try {
      // Simulate API call with a 1-second delay
      let body = null;
      console.log("Saving data to API:", offer);

      body = {
        target: "gpShortlistOffer",
        GPOfferExtendedInput: {
          GPOfferID: offer.GPOfferID,
          OfferStatus: "Shortlist",
          Margin: offer.Margin,
          CategoryType: "rfq",
          GPEmailID: activeUser,
          RequirementsID: requirementDetails.RequirementsID,
        },
      };

      console.log("Saving body to API:", body);
      if (body !== null) {
        const result = await postQuery(body, "backendops");
        console.log("result@", result);
        if (result) {
          setModal({
            show: true,
            type: "success",
            title: "Success",
            message: `Offer shortlisted successfully!`,
            autoClose: false,
            nextAction: () => {
              onResponse(true);
              sendTrueToParent();
              setSelectedOffer(null);
            },
          });
        }
      }

      // Refresh the table data
      await fetchMatchingOffers(searchValues, rowStart);
    } catch (error) {
      console.error("Error saving data:", error);
      setModal({
        show: true,
        type: "error",
        title: "Error",
        message: "Failed to shortlist offer. Please try again.",
        autoClose: false,
      });
    } finally {
      setLoading(false);
    }
  };
  const handleNegotiate = async (offer) => {
    setLoading(true);
    console.log("handleNegotiate triggered");
    console.log("negotiateOffer::", offer);
    try {
      // Simulate API call with a 1-second delay
      let body = null;
      console.log("Saving data to API:", offer);

      // body = {
      //   target: "gpExtendedOfferUpdate",
      //   GPOfferExtendedInput: {
      //     // Deleted: 0,
      //     OfferStatus: "Firmoffer",
      //     GPOfferExtendedID: offer.GPOfferExtendedID,
      //   },
      // };
      body = {
        target: "gpShortlistOffer",
        GPOfferExtendedInput: {
          GPOfferID: offer.GPOfferID,
          OfferStatus: "Firmoffer",
          Margin: offer.Margin,
          CategoryType: "rfq",
          GPEmailID: activeUser,
          RequirementsID: requirementDetails.RequirementsID,
        },
      };

      console.log("Saving body to API:", body);
      if (body !== null) {
        const result = await postQuery(body, "backendops");
        console.log("result@", result);
        if (result) {
          setModal({
            show: true,
            type: "success",
            title: "Success",
            message: `Send Firm Offer successfully!`,
            autoClose: false,
            nextAction: () => {
              setSelectedOffer(null);
            },
          });
        }
      }

      // Refresh the table data
      await fetchMatchingOffers(rowStart);
    } catch (error) {
      console.error("Error saving data:", error);
      setModal({
        show: true,
        type: "error",
        title: "Error",
        message: "Failed to send firm offer. Please try again.",
        autoClose: false,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSaveExtendedOffer = async (offer, OfferStatus) => {
    setLoading(true);
    console.log(offer, requirementDetails);
    try {
      let body = {
        target: "gpShortlistOffer",
        GPOfferExtendedInput: {
          GPOfferID: offer.GPOfferID,
          OfferStatus: OfferStatus,
          Remarks: firmOfferModal.remarks,
          Margin: offer.Margin,
          CategoryType: "rfq",
          GPEmailID: activeUser,
          RequirementsID: requirementDetails.RequirementsID,
        },
      };

      console.log("Saving body to API:", body);
      const result = await postQuery(body, "backendops");
      console.log("result@", result);

      if (result) {
        setModal({
          show: true,
          type: "success",
          title: "Success",
          message: `${
            OfferStatus === "BAFO"
              ? "BAFO"
              : OfferStatus === "Query"
              ? "Query"
              : "Firm offer"
          } sent successfully!`,
          autoClose: false,
          nextAction: () => {
            setSelectedOffer(null);
          },
        });
      }
    } catch (error) {
      console.error("Error saving data:", error);
      setModal({
        show: true,
        type: "error",
        title: "Error",
        message: `Failed to send ${
          OfferStatus === "BAFO"
            ? "BAFO"
            : OfferStatus === "Query"
            ? "query"
            : "firm offer"
        }. Please try again.`,
        autoClose: false,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSendffer = (offer, type) => {
    setFirmOfferModal({
      show: true,
      offer: offer,
      remarks: "",
      type: type,
    });
  };

  const handleOfferSubmit = async () => {
    if (firmOfferModal.offer) {
      await handleSaveExtendedOffer(firmOfferModal.offer, firmOfferModal.type);
      setFirmOfferModal({
        show: false,
        offer: null,
        remarks: "",
        type: "",
      });
      await fetchMatchingOffers(searchValues, rowStart);
    }
  };

  const handleFirmOfferCancel = () => {
    setFirmOfferModal({
      show: false,
      offer: null,
      remarks: "",
      type: "",
    });
  };

  const getProductDetails = useCallback(
    async (productId) => {
      try {
        const matchingProducts = allProductMaster.filter(
          (p) => p.ProductID === productId
        );
        console.log("matchingProducts@@", matchingProducts);
        if (matchingProducts.length > 0) {
          setProductDetails({
            ProductName: matchingProducts[0].ProductName,
            Grade: matchingProducts[0].Grade,
          });
        }
      } catch (error) {
        console.error("Error fetching product details:", error);
        setProductDetails({});
      }
    },
    [allProductMaster]
  );

  const currentPage = Math.floor(rowStart / pageSize) + 1;

  const fields = [
    // {
    //   name: "searchOfferProduct",
    //   label: "Product",
    //   type: "dropdown",
    //   options: productList.map((item) => ({
    //     value: item.ProductName,
    //     label: item.ProductName,
    //   })),
    //   value: searchValues.searchOfferProduct,
    //   onChange: (value) => {
    //     setSearchValues((prev) => ({ ...prev, searchOfferProduct: value }));
    //     loadProductGrades(value);
    //   },
    // },
    // {
    //   name: "searchOfferProductGrade",
    //   label: "Product Grade",
    //   type: "dropdown",
    //   options: productGradeList.map((item) => ({
    //     value: item.Grade,
    //     label: item.Grade,
    //   })),
    //   value: searchValues.searchOfferProductGrade,
    //   onChange: (value) => {
    //     setSearchValues((prev) => ({
    //       ...prev,
    //       searchOfferProductGrade: value,
    //     }));
    //   },
    // },
    {
      name: "searchPriceRange",
      label: "Price Range (USD)",
      type: "dropdown",
      options: priceOptions,
      value: searchValues.searchPriceRange,
      onChange: (value) => {
        setSearchValues((prev) => ({ ...prev, searchPriceRange: value }));
        fetchMatchingOffers({ ...searchValues, searchPriceRange: value }, 0);
      },
    },
  ];

  const columns = [
    { id: "OfferNumber", numeric: false, label: "Offer No." },
    { id: "ProductName", numeric: false, label: "Product" },
    { id: "Grade", numeric: false, label: "Grade" },
    {
      id: "Quantity",
      numeric: true,
      label: "Quantity (MT)",
      renderCell: (row) => formatPrice(row.Quantity),
    },
    {
      id: "FOBSalePrice",
      numeric: true,
      label: "FOB Sale Price (USD)",
      renderCell: (row) => row.FOBSalePrice,
    },
    { id: "Country", numeric: false, label: "Origin Country" },
    { id: "DestinationCountry", numeric: false, label: "Destination" },
    { id: "INCO", numeric: false, label: "INCO Terms" },
    {
      id: "GPOOfferStatus",
      numeric: false,
      label: "Offer Status",
      renderCell: (row) => {
        let bgColor = "";
        let textColor = "";

        switch (row.GPOOfferStatus) {
          case "BAFO":
            bgColor = "#e0f2fe";
            textColor = "#0369a1";
            break;
          case "Firmoffer":
            bgColor = "#d1fae5";
            textColor = "#065f46";
            break;
          default:
            bgColor = "#fef3c7";
            textColor = "#b45309";
            // row.OfferStatus = "Indicative"; // Set default status
            break;
        }

        return (
          <span
            style={{
              backgroundColor: bgColor,
              color: textColor,
              padding: "4px 10px",
              borderRadius: "999px",
              fontSize: "0.75rem",
              fontWeight: 500,
            }}
          >
            {row.GPOOfferStatus}
          </span>
        );
      },
    },
    {
      id: "CreatedAt",
      numeric: false,
      label: "Created Date",
      renderCell: (row) => formatDate(row.CreatedAt),
    },
    {
      id: "Expires",
      numeric: false,
      label: "Expires",
      renderCell: (row) => formatDate(row.Expires),
    },
    {
      id: "KYBStatus",
      numeric: false,
      label: "Seller Status",
      renderCell: (row) => {
        let bgColor = "";
        let textColor = "";

        switch (row.KYBStatus) {
          case "Approved":
            bgColor = "#d1fae5";
            textColor = "#065f46";
            break;
          default:
            bgColor = "#fef3c7";
            textColor = "#b45309";
        }

        return (
          <span
            style={{
              backgroundColor: bgColor,
              color: textColor,
              padding: "4px 10px",
              borderRadius: "999px",
              fontSize: "0.75rem",
              fontWeight: 500,
              display: "inline-block",
            }}
          >
            {row.KYBStatus === "Approved" ? "Verified" : "Unverified"}
          </span>
        );
      },
    },
  ];

  useEffect(() => {
    loadAllProducts();
  }, [loadAllProducts]);

  useEffect(() => {
    if (requirementDetails && productList.length > 0) {
      fetchMatchingOffers(searchValues);
    }
  }, [
    rowStart,
    pageSize,
    requirementDetails,
    fetchMatchingOffers,
    searchValues,
    productList,
  ]);

  return (
    <div>
      <AlertModal
        type={modal.type}
        title={modal.title}
        message={modal.message}
        showModal={modal.show}
        onClose={handleModalClose}
        buttonText="OK"
        autoClose={modal.autoClose}
      />
      <div className="search-filter4">
        <div className="title4">
          <div className="head-text">Matching Offers</div>
        </div>
        <div className="filter4">
          <SearchFilter fields={fields} onSearch={handleSearch} />
        </div>
      </div>

      <DataTable
        columns={columns}
        data={offerList}
        total={totalItems}
        title="Matching Offers"
        rowsPerPage={pageSize}
        onPageChange={handlePageChange}
        currentPage={currentPage}
        onRowClick={handleRowClick}
        selectedRows={selectedOffer ? [selectedOffer.GPOfferID] : []}
      />
      {selectedOffer && (
        <div className="offer-detail1">
          <div className="header-text-re">
            <div className="head-text">Offer Details</div>
            {selectedOffer ? (
              selectedOffer.GPOExtendedStatus === "Shortlist" ? (
                <>
                  <Button label="Verification Status" onClick={trustModel} />
                  <button
                    style={{ width: "150px" }}
                    className="submit-btn-more"
                  >
                    Shortlisted
                  </button>
                </>
              ) : selectedOffer.GPOExtendedStatus === "Firmoffer" ? (
                <>
                  <Button label="Verification Status" onClick={trustModel} />
                  <button
                    style={{ width: "150px" }}
                    className="submit-btn-more"
                  >
                    Send Firm Offer
                  </button>
                </>
              ) : selectedOffer.GPOExtendedStatus === "BAFO" ? (
                <>
                  <Button label="Verification Status" onClick={trustModel} />
                  <button
                    style={{ width: "150px" }}
                    className="submit-btn-more"
                  >
                    BAFO
                  </button>
                </>
              ) : selectedOffer.GPOExtendedStatus === "Query" ? (
                <>
                  <Button label="Verification Status" onClick={trustModel} />
                  <button
                    style={{ width: "150px" }}
                    className="submit-btn-more"
                  >
                    Queried Offer
                  </button>
                </>
              ) : selectedOffer.GPOExtendedStatus === "Accepted" ? (
                <>
                  <Button label="Verification Status" onClick={trustModel} />
                  <button
                    style={{ width: "150px" }}
                    className="submit-btn-more"
                  >
                    Accepted
                  </button>
                </>
              ) : (
                <div className="button-group">
                  <Button label="Verification Status" onClick={trustModel} />
                  <Button
                    label="Shortlist"
                    onClick={() => handleShortlist(selectedOffer)}
                  />
                  <Button
                    label="Send Firm Offer​"
                    onClick={() => handleSendffer(selectedOffer, "Firmoffer")}
                  />
                  <Button
                    label="Send BAFO"
                    onClick={() => handleSendffer(selectedOffer, "BAFO")}
                  />
                  <Button
                    label="Ask seller a question​"
                    onClick={() => handleSendffer(selectedOffer, "Query")}
                  />
                </div>
              )
            ) : (
              <div></div>
            )}
          </div>

          <OfferDetails
            offer={selectedOffer}
            btnShortlist={false}
            btnSendQuery={false}
            btnRequestQuote={false}
            btnRequestSpecifications={false}
            btnRequestBestPrice={false}
            btnNegotiate={false}
            btnRequestShippingDetails={false}
            btnLogisticsSupport={false}
            INRToUsd={INRToUsd}
            activeUser={activeUser}
            requirementDetails={requirementDetails}
            onResponse={handleOfferResponse}
          />
        </div>
      )}
      {/* Verification Status Modal */}
      {trustModal && selectedOffer && (
        <TrustScoreModal
          onClose={() => setTrustModal(false)}
          userEmail={selectedOffer.SellerEmailID}
        />
      )}
      {/* Firm Offer Modal */}
      {firmOfferModal.show && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            className="modal-content"
            style={{
              backgroundColor: "white",
              padding: "24px",
              borderRadius: "8px",
              width: "500px",
              maxWidth: "90vw",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            <div
              className="modal-header"
              style={{
                marginBottom: "20px",
                borderBottom: "1px solid #e5e7eb",
                paddingBottom: "16px",
              }}
            >
              <h3
                style={{
                  margin: 0,
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#1f2937",
                }}
              >
                {firmOfferModal.type === "BAFO"
                  ? "Send BAFO"
                  : firmOfferModal.type === "Query"
                  ? "Ask seller a question"
                  : "Send Firm Offer"}
              </h3>
            </div>

            <div className="modal-body" style={{ marginBottom: "24px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#374151",
                }}
              >
                Remarks
              </label>
              <textarea
                value={firmOfferModal.remarks}
                onChange={(e) =>
                  setFirmOfferModal((prev) => ({
                    ...prev,
                    remarks: e.target.value,
                  }))
                }
                placeholder="Enter your remarks here..."
                rows={4}
                style={{
                  width: "100%",
                  padding: "12px",
                  border: "1px solid #d1d5db",
                  borderRadius: "6px",
                  fontSize: "14px",
                  resize: "vertical",
                  outline: "none",
                  fontFamily: "inherit",
                }}
              />
            </div>

            <div
              className="modal-footer"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "12px",
              }}
            >
              <button
                onClick={handleFirmOfferCancel}
                style={{
                  padding: "8px 16px",
                  border: "1px solid #d1d5db",
                  backgroundColor: "white",
                  color: "#374151",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                Cancel
              </button>
              <button onClick={handleOfferSubmit} className="submit-btn-more">
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MatchingOffers;
